export default __webpack_public_path__ + "assets/dict.6e62ed3b.svg";